import IconNames from '@hapvida/hapvida-core-components/src/assets/icons/IconNames';
import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

enum BeneficiaryServicesStatusEnum {
  Active = 'Ativo',
  Inactive = 'Inativo',
}

const BeneficiaryServicesName: Record<BeneficiaryServicesStatusEnum, string> = {
  [BeneficiaryServicesStatusEnum.Inactive]: 'Inativo',
  [BeneficiaryServicesStatusEnum.Active]: 'Ativo',
};

const BeneficiaryServicesColors: Record<BeneficiaryServicesStatusEnum, string> =
  {
    [BeneficiaryServicesStatusEnum.Active]: NEW_COLORS.SEMANTICS.SUCCESS[500],
    [BeneficiaryServicesStatusEnum.Inactive]: NEW_COLORS.SEMANTICS.ERROR[600],
  };

const BeneficiaryServicesIconName: Record<
  BeneficiaryServicesStatusEnum,
  IconNames
> = {
  [BeneficiaryServicesStatusEnum.Active]: 'actions-b2b-check-circle',
  [BeneficiaryServicesStatusEnum.Inactive]: 'actions-b2b-alert',
};

export {
  BeneficiaryServicesColors,
  BeneficiaryServicesIconName,
  BeneficiaryServicesName,
  BeneficiaryServicesStatusEnum,
};
